import React from "react";
import { Helmet } from "react-helmet";
import { Card, CardBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import HeaderThree from "../component/header/HeaderThree";
import { beeFrameworkContent } from "./beeFrameworkContent";

const SUPPORTED_LANGS = ["en", "fr", "de", "nl"];

// Public, no-login page publishing the EcoShift bee reference framework.
// The content itself (src/home/beeFrameworkContent.js) is pasted verbatim, one
// self-contained block per language, and must not be edited: every wording is
// legal content and label names are intentionally identical across languages.
const BeeFrameworkPage = () => {
  const { t, i18n } = useTranslation();
  const icon = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive.webp`;
  const title = t("EcoShift bee reference framework");
  const lang = SUPPORTED_LANGS.includes(i18n.language) ? i18n.language : "en";

  window.onload = function () {
    document.querySelector(".header--fixed").classList.add("sticky");
  };

  return (
    <div className="active-dark bg_color--ugs">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content="EcoShift ⁕ the digital platform for your eco-positive consumption!" />
        <meta
          name="keywords"
          content="ecoshift,shift,impact,transition,eco,friendly,consumption,eco-positive,sustainability,biodiversity,ecoresponsible,bee,label,certification"
        />
        <meta property="og:title" content={title} />
        <meta property="og:description" content="EcoShift ⁕ the digital platform for your eco-positive consumption!" />
        <meta property="og:image" content={icon} />
        <meta property="og:url" content={process.env.PUBLIC_URL + "/"} />
        <meta name="twitter:card" content={icon} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://ecoshift.eco/bee-framework" />
      </Helmet>

      <HeaderThree homeLink="/" logo="symbol-dark" color="color-black" alwaysSticky="true" />

      <Card id="bee-framework" className="card_color--ugs ">
        <CardBody>
          <div className="slider-wrapper">
            <div className="fix top-inset-main">
              <div className="service-area creative-service-wrapper pb--80 card_color--ugs ">
                <div className="container">
                  {/* Clears the fixed header, whose height varies with nav wrapping (up to ~190px) */}
                  <div style={{ height: 220 }} />
                  <div className="row">
                    <div className="col-lg-12 mb_sm--0">
                      <p className="section-title-left mb-4">{title}</p>
                      <div key={lang} dangerouslySetInnerHTML={{ __html: beeFrameworkContent[lang] }} />
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default BeeFrameworkPage;
